<div class="av-unsupported-device d-flex flex-column w-100">
  <header
    class="av-unsupported-device__header d-flex justify-content-between align-items-center w-100 py-4 px-4"
  >
    <img
      src="/assets/icons/avyna/logo.svg"
      class="av-unsupported-device__brand"
      [alt]="'app.unsupported_device.brand_alt' | translate"
    />
    <av-language-dropdown />
  </header>

  <main class="av-unsupported-device__main flex-grow-1 d-flex flex-column overflow-auto">
    <div class="av-unsupported-device__card w-100">
      <av-content-container class="w-100">
        <div
          class="av-unsupported-device__panel w-100 d-flex flex-column align-items-center justify-content-center"
        >
          <av-empty-state
            icon="computer"
            titleKey="app.unsupported_device.title"
            subtitleKey="app.unsupported_device.subtitle"
          />
        </div>
      </av-content-container>
    </div>
  </main>

  <footer
    class="av-unsupported-device__footer d-flex align-items-center justify-content-center px-4 pb-3"
  >
    <av-theme-toggle />
  </footer>
</div>
